<template lang="pug">


    table.ui.small.fixed.very.basic.table

        //- Kostenstelle
        tbody.zk.gi.row.bordered(
            is='text-field-row'
            v-model='productModel'
            property='costCenter'
            label='Kostenstelle'
        )

        //- Kontaktperson
        tbody.zk.gi.row.bordered(
            is='contact-field-row'
            v-bind:companyModel='companyModel'
            v-bind:personModels='personModels'
            v-bind:productModel='productModel'
        )

        //- Kampagne
        tbody.zk.gi.row.bordered(
            is='campaign-field-row'
            v-bind:campaignModels='campaignModels'
            v-bind:companyModel='companyModel'
            v-bind:productModel='productModel'
        )

        //- Liefertermin
        tbody.zk.gi.row.bordered(
            is='date-field-row'
            v-model='productModel'
            property='deliveryDate'
            label='Liefertermin'
        )

        //- Druck an ZMÜK
        tbody.zk.gi.row.bordered(
            is='date-field-row'
            v-model='productModel'
            property='printingMaterialToZmuek'
            label='Druck an ZMÜK'
        )

        //- Agentur
        tbody.zk.gi.row.bordered(
            is='agency-field-row'
            v-bind:product='productModel'
            v-bind:agencies='agencyModels'
        )

        //- Freitext 1
        tbody.zk.gi.row.bordered(
            is='text-field-row'
            v-if='companyModel.freeText1'
            v-model='productModel'
            property='freeText1'
            v-bind:label='companyModel.freeText1'
        )

        //- Freitext 2
        tbody.zk.gi.row.bordered(
            is='text-field-row'
            v-if='companyModel.freeText2'
            v-model='productModel'
            property='freeText2'
            v-bind:label='companyModel.freeText2'
        )

        //- Freitext 3
        tbody(
            is='text-field-row'
            v-if='companyModel.freeText3'
            v-model='productModel'
            property='freeText3'
            v-bind:label='companyModel.freeText3'
        )

</template>

<script>
    import AgencyFieldRow from './general-information/AgencyFieldRow'
    import CampaignFieldRow from './general-information/CampaignFieldRow'
    import ContactFieldRow from './general-information/ContactFieldRow'
    import DateFieldRow from './general-information/DateFieldRow'
    import TextFieldRow from './general-information/TextFieldRow'

    export default {

        components: {
            AgencyFieldRow, CampaignFieldRow, ContactFieldRow, DateFieldRow, TextFieldRow
        },

        props: {

            agencyModels: {
                type: Array,
                required: true
            },

            campaignModels: {
                type: Array,
                required: true
            },

            companyModel: {
                type: Object,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            },

            productModel: {
                type: Object,
                required: true
            },

        }

    }

</script>

<style scoped>
    .zk.gi.row.bordered td {
        border-bottom: 1px solid rgba(0,0,0,.1);
    }
</style>
